<template>
  <div id="role">
    <div id="role-main">
      <div id="role-shows">
        <img
          class="shows-head"
          v-for="(item, index) in showsHead"
          :key="'head-'+index"
          :id="item"
          :src="item==activeRole?require('../assets/images/'+item+'-active.png'):require('../assets/images/'+item+'.png')"
        />
        <!-- <img id="es" src="../assets/images/es.png"/> -->
        <div
          class="box"
          v-for="(item, index) in showsHead"
          :key="'box-'+index"
          :id="item+'-box'"
          @click.stop="changeRole(item)"
          ></div>
      </div>
      <div id="role-intro">
        <div id="intro-title">
          <p id="title-big">{{ $t("role." + activeRole + ".name") }}</p>
          <p id="title-normal">{{ $t("role." + activeRole + ".name") }}</p>
          <img id="title-de1" src="../assets/images/title-de1.png"/>
          <img id="title-de2" src="../assets/images/title-de2.png"/>
        </div>
        <div id="intro-content">
          {{ $t("role." + activeRole + ".intro") }}
        </div>
      </div>
      <img
        id="role-image"
        :src="require('../assets/images/' + activeRole + '-back.png')"
      />
      <img
        id="role-bottom"
        :src="require('../assets/images/' + activeRole + '-bottom.png')"
      />
      <img id="play" src="../assets/images/role-video.png" @click.stop="toggleVideo(true)"/>
      <Download id="role-download"/>
    </div>
    <div id="role-video" v-if="videoShow" @click.self="toggleVideo(false)">
      <video id="video-main" :src="require('../assets/video/' + activeRole + '.mp4')" autoplay loop controls>
        {{ $t("role.playerWarning") }}
      </video>
      <img id="close" src="../assets/images/close.png" @click.stop="toggleVideo(false)"/>
    </div>
  </div>
</template>

<script>
import Download from "@/components/Download.vue";

export default {
  components: {
    Download,
  },
  data() {
    return {
      videoShow: false,
      activeRole: "rg",
      showsHead: ["rg","a","hk","hb","nol","kk","ma","es"],
    };
  },
  methods: {
    changeRole(role) {
      this.activeRole = role;
    },
    toggleVideo(bol){
      this.videoShow = bol
    }
  },
};
</script>

<style scoped>
#role-main {
  width: 100%;
  height: 100%;
  background-image: url("../assets/images/role-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
#role-shows {
  width: 553px;
  height: 712px;
  position: absolute;
  left: 0;
  top: 50px;
  background-image: url("../assets/images/shows-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
.shows-head {
  width: 200px;
  height: 178px;
}
#rg{
  position: absolute;
  top: 168px;
  right: 196px;
}
#rg-box{
  position: absolute;
  top: 180px;
  right: 242px;
}
#a{
  position: absolute;
  top: 188px;
  right: 93px;
}
#a-box{
  position: absolute;
  top: 240px;
  right: 140px;
}
#hk{
  position: absolute;
  top: 168px;
  right: -12px;
}
#hk-box{
  position: absolute;
  top: 180px;
  right: 32px;
}
#hb{
  position: absolute;
  top: 188px;
  right: -115px;
}
#hb-box{
  position: absolute;
  top: 240px;
  right: -70px;
}
#nol{
  position: absolute;
  bottom: 166px;
  right: 196px;
}
#nol-box{
  position: absolute;
  bottom: 180px;
  right: 242px;
}
#kk{
  position: absolute;
  bottom: 184px;
  right: 93px;
}
#kk-box{
  position: absolute;
  bottom: 238px;
  right: 138px;
}
#es {
  position: absolute;
  bottom: 166px;
  right: -12px;
}
#es-box {
  position: absolute;
  bottom: 166px;
  right: 32px;
}
#ma{
  position: absolute;
  bottom: 184px;
  right: -115px;
}
#ma-box{
  position: absolute;
  bottom: 238px;
  right: -70px;
}
.box{
  width: 110px;
  height: 110px;
  z-index: 99;
  border-radius: 65px;
  cursor: pointer;
}
#role-intro{
  position: absolute;
  top: 40px;
  left: 560px;
  z-index: 9;
}
#intro-title{
  width: 540px;
  position: relative;
  font-weight: 800;
}
#title-big {
  font-size: 110px;
  color: transparent;
  -webkit-text-stroke: 3px #211066;
}
#title-normal {
  position: absolute;
  top: 40px;
  left: 100px;
  font-size: 75px;
  color: #fff;
}
#title-de2{
  width: 67px;
  height: 37px;
  display: inline-block;
  position: absolute;
  top: 53px;
  right: 35px;
}
#title-de1{
  width: 570px;
  height: 3px;
  display: inline-block;
  position: absolute;
  top: 145px;
  right: 95px;
}
#intro-content{
  width: 300px;
  font-size: 18px;
  font-weight: 800;
  color: #adaeb5;
  margin-left: 140px;
}
#role-image{
  width: 1626px;
  height: 831px;
  position: absolute;
  top: 0;
  right: 100px;
}
#role-bottom{
  width: 1920px;
  height: 361px;
  position: absolute;
  bottom: 0;
  left: 0;
}
#play{
  width: 358px;
  height: 253px;
  position: absolute;
  right: 200px;
  bottom: 180px;
  cursor: pointer;
}
#role-video{
  width: 100%;
  height: calc(100% + 97px);
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  left: 0;
  top: -97px;
  z-index: 999;
}
#video-main{
  width: 1190px;
  height: auto;
  position: absolute;
  top: 200px;
  left: 50%;
  margin-left: -595px;
  z-index: 9999;
}
#close{
  width: 39px;
  height: 39px;
  position: absolute;
  top: 150px;
  right: 200px;
  z-index: 9999;
  cursor: pointer;
}
#role-download{
  width: 310px;
  height: auto;
  position: absolute;
  left: 0;
  bottom: 40px;
  cursor: pointer;
}
</style>
